import { Grid, Space, Text, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { CreatePartnerDetailsForm } from '../../../../type/entity.types';
import XCol4 from '../../../x-components/grid-col/x-col-4.component';

function PartnerDetails(props: Props) {
  const { form, isAdmin } = props;

  return (
    <>
      <Text size='xl' weight={700}>
        Partner Details
      </Text>
      <Space h='xl' />
      <Grid>
        <XCol4>
          <TextInput
            label={labels.entityName}
            placeholder={placeholders.entityName}
            {...form.getInputProps('entityName')}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.emailAddress}
            placeholder={placeholders.emailAddress}
            {...form.getInputProps('email')}
          />
        </XCol4>
        {isAdmin && (
          <XCol4>
            <TextInput
              label={labels.MDR}
              placeholder={placeholders.MDR}
              {...form.getInputProps('MDR')}
            />
          </XCol4>
        )}
      </Grid>
    </>
  );
}

export default PartnerDetails;

interface Props {
  form: UseFormReturnType<CreatePartnerDetailsForm>;
  isAdmin: boolean;
}

const labels = {
  entityName: 'Partner name',
  emailAddress: 'Company email',
  MDR: 'MDR',
};
const placeholders = {
  entityName: 'Partner name',
  emailAddress: 'Company email',
  MDR: 'Merchant discount rate',
};
